import styles from "./sub-header-info.module.css";

interface IProps {
  alt: string;
  textInfo: string;
  icon: any;
}

const SubHeaderInfo = ({ alt, textInfo, icon }: IProps) => {
  const handleClick = () => {
    if (alt === "email") {
      window.location.href = "mailto:contato@truevidence.com.br";
    } else if (alt === "linkedin") {
      window.open("https://www.linkedin.com/company/truevidence/", "_blank");
    }
  };

  return (
    <div className={styles.sub_header_info} onClick={handleClick}>
      <img
        className={styles.icon_img}
        src={icon}
        alt={`Ícone ${alt} sub header.`}
        loading="lazy"
      />
      <span className={styles.text_info}>{textInfo}</span>
    </div>
  );
};

export default SubHeaderInfo;
